module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.initialized || _vm.initComponent === 'Login') ? [_c(_vm.initComponent, {
    tag: "component",
    on: {
      "login-success": _vm.loginSuccess
    }
  })] : [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    attrs: {
      "element-loading-text": "正在初始化应用，请稍等···"
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71eb1c58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1422
// module chunks = 1